// extracted by mini-css-extract-plugin
export default {"skills":"skillsStyles_skills__ZCUHD"};